import { FC, ReactNode } from 'react'

const Modal: FC<{ id: string; content: ReactNode }> = ({ id, content }) => {
  return (
    <div
      id={id}
      className="Modal is-closed"
      data-modal
      role="dialog"
      aria-hidden="true"
    >
      <div className="Modal-overlay" data-target={id}></div>
      <div
        className="Modal-container bg-white rounded-lg"
        tabIndex={-1}
        role="document"
        aria-label="Modal"
        style={{ maxWidth: '700px' }}
      >
        <div className="pt-8 px-8 text-left overflow-auto">{content}</div>
        <button
          className="Modal-close"
          type="button"
          aria-label="Close modal"
          data-target={id}
        ></button>
      </div>
    </div>
  )
}

export default Modal
